import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

interface UnassignMissionFromTripFolderInput {
  id: number
  missionId: number
}

export function unassignMissionFromTripFolder(input: UnassignMissionFromTripFolderInput) {
  const { id, missionId } = input
  return restApiClient
    .url(constructApiUrl(API.tripFolder.unassignMission.url, { id, missionId }))
    .post()
}
